import { render, staticRenderFns } from "./Erradicacion.vue?vue&type=template&id=53dcdac5&scoped=true&"
import script from "./Erradicacion.vue?vue&type=script&lang=ts&"
export * from "./Erradicacion.vue?vue&type=script&lang=ts&"
import style0 from "./Erradicacion.vue?vue&type=style&index=0&id=53dcdac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dcdac5",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QImg from 'quasar/src/components/img/QImg.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList,QItem,QItemSection,QIcon,QImg});qInstall(component, 'directives', {Ripple});
